import React from 'react';

const MenuCard = ({menuData}) => {
  
  
  return (
    <>
    <section className='main-card--cointainer'>
        {menuData.map((curElem) =>{
            return(
                <div className='card-container' key={curElem.id}>
                <div className='card-body'>
                {/* <span className='card-number card-circle subtle'>{curElem.id}</span> */}
                <span className='card-author subtle'>{curElem.name}</span>
                
                </div>
                <img src={curElem.image} alt="images" className='card-media'/>
                

                
                <a href={curElem.image} download><span className='card-tag subtle'>Download</span>
                </a>
                </div> 
            )
        })}
        {/* <h1>Anime Wallpaper Downloader</h1> */}
    </section>
    </>
  )
}



export default MenuCard;